export const BASE = {
  name: 'sso',
  path: '/settings/sso',
};

export const LIST = {
  name: 'sso.list',
};

export const NO_ACCESS = {
  name: 'sso.no_access',
};

export const SIGN_IN = {
  name: 'ssoSignIn',
  path: '/login/sso',
};
